<template>
  <v-card class="ma-2">
    <v-card-title>Tarifas de precios</v-card-title>
    <v-card-subtitle>A continuación le informamos de nuestras tarifas de precios que le facturaremos en casos de
      reparaciones requeridas por usted o aquellas que habiéndose solicitado en garantía no procedan.
    </v-card-subtitle>
    <v-simple-table id="table">
      <thead>
      <tr>
        <th class="text-left">CONCEPTO</th>
        <th class="text-left">PRECIO SIN IVA</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="concept in concepts" :key="concept.label">
        <td>{{ concept.label }}</td>
        <td>{{ concept.value }}</td>
      </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: "Concepts",
  data() {
    return {
      concepts: [
        {label: "Mano obra oficial", value: "35,00 €"},
        {label: "Mano obra ayudante", value: "20,00 €"},
        {label: "Disposición de servicio", value: "20,00 €"},
        {label: "Kilometraje", value: "0,20 € /km"},
        {label: "Recambios o materiales fuera de garantía", value: "Según tarifa"},
      ]
    }
  }
}
</script>

<style scoped>
</style>